import * as yup from 'yup';

export interface UserModel {
  _id?: string;
  mobileNo?: string;
  name?: string | null;
  email?: string | null;
  isMerchant?: number;
  isCustomer?: number;
  isDraft?: number;
  isCompleteRegister?: number;
  status?: number;
  createdBy?: string;
  createdDate?: string;
  modifiedBy?: string;
  modifiedDate?: string;
  // non db fields
  intialName?: string;

  // others
  [x: string]: any;
}

export interface UserLoginModel {
  mobileNo: string;
  password: string;
}

export interface UserStateModel {
  user: UserModel | null;
  loginStatus?: boolean | null;
  validateStatus?: boolean | null;
  isLogout?: boolean | null;
  errorMsg: string | null;
}

export interface UserPasswordModel {
  oldPassword: string;
  newPassword: string;
}

export const UserInputSchema = yup.object().shape({
  // isEdit
  mobileNo: yup.string().when('$isNew', {
    is: true,
    then: fs => fs.required('Mobile Number is required.').min(10, 'Mobile Number must be a valid mobile number.'),
  }),
  password: yup.string().when('$isNew', {
    is: true,
    then: fs =>
      fs.required('Password is required.').when('password', {
        is: (password: string) => password !== '',
        then: fs1 =>
          fs1
            .min(8, 'Password must be at least 8 characters long.')
            .matches(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
              'Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character',
            ),
      }),
  }),

  confirmPassword: yup.string().when('$isNew', {
    is: true,
    then: fs => {
      return fs.required('Confirm password is required.').oneOf([yup.ref('password'), ''], 'Passwords must match');
    },
  }),

  name: yup.string().required('Name is required.'),
  email: yup.string().email('Email format is incorrect.').required('Email is required.').nullable(),
  dob: yup.date().max(new Date(), 'No future date for Bidthdate').nullable().typeError('Birthdate must be a date.'),

  state: yup.string().nullable(),
  city: yup.string().nullable(),

  phone: yup.string().nullable(),
});
